import {
  Button,
  ComboboxItem,
  Grid,
  GridCol,
  Input,
  NumberFormatter,
  Select,
} from "@mantine/core";
import { modals } from "@mantine/modals";
import {
  IconBuilding,
  IconBuildingStore,
  IconSearch,
  IconUserCircle,
} from "@tabler/icons-react";
import { CellDoubleClickedEvent } from "ag-grid-community";
import {
  MantineReactTable,
  MRT_ColumnDef,
  MRT_PaginationState,
  MRT_RowSelectionState,
  useMantineReactTable,
} from "mantine-react-table";
import React, { useEffect, useState } from "react";
import {
  _timerDelayClick,
  repositoryPos,
  styleTableMantine,
} from "../../../../_base/_const/_constVar";
import { SelectListItemBase } from "../../../../_base/model/_base/SelectListItemBase";
import { _localization } from "../../../../config/location";
import { cobalt_blue } from "../../../../const/variables";
import { EmployeeModel } from "../../../../model/Employee";
import { MessageResponse } from "../../../../model/MessageResponse";
import {
  getTblDepartmentSelect,
  getTblRoleSelect,
} from "../../../../service/getSelectApi";

const CustomerByBranch = ({
  handleChooseCustomer,
  navigate,
  isChooseCongNo,
  openFormCustomer,
  disible,
  children,
  RowIndex,
  paramDetailsEditEmployeeByBranch,
}: {
  handleChooseCustomer: Function;
  navigate?: any;
  isChooseCongNo: boolean;
  openFormCustomer?: any;
  disible?: boolean;
  children?: boolean;
  RowIndex?: number;
  paramDetailsEditEmployeeByBranch?: CellDoubleClickedEvent<any>;
}) => {
  const [data, setData] = useState<EmployeeModel[]>([]);
  const [dataTemp, setDataTemp] = useState<any[]>([]);
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  const [height, setHeight] = useState(0);
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const [customerInfo, setCustomerInfo] = useState<MRT_RowSelectionState>({});
  const [dataDepartment, setDataDepartment] = useState<ComboboxItem[]>([]);
  const [dataRole, setDataRole] = useState<ComboboxItem[]>([]);
  const [isFirstFetch, setIsFirstFetch] = useState(true);
  const [selectIds, setSelectIds] = useState<string[]>([]);
  const [deleteViewStatus, setDeleteViewStatus] = useState(false);
  const [timeLeft, setTimeLeft] = useState(60);
  const [isCounting, setIsCounting] = useState(false);
  const [search, setSearch] = useState({
    roleId: "",
    departmentId: "",
    managerId: "",
    branchId: "",
    keySearch: "",
  });
  const [dataBranch, setDataBranch] = useState<SelectListItemBase[]>([]);

  const [pagination, setPagination] = useState<MRT_PaginationState>({
    pageIndex: 0,
    pageSize: 25,
  });
  const [dataProvinceSelect, setDataProvinceSelect] = useState<ComboboxItem[]>(
    []
  );
  const headerRef = React.useRef<HTMLDivElement>(null);
  const sizeGrid = { base: 6, sm: 4, md: 3, lg: 3, xl: 2 };

  const [dataTblCustomerGroup, setDataTblCustomerGroup] = useState<any[]>([]);
  const columns = React.useMemo<MRT_ColumnDef<EmployeeModel>[]>(
    () =>
      [
        {
          accessorKey: "id",
          header: "Id",
        },
        {
          accessorKey: "code",
          header: "Mã nhân viên",
        },
        {
          accessorKey: "fullname",
          header: "Tên nhân viên",
          size: 250,
        },
        {
          accessorKey: "email",
          header: "Email",
          //  enableGrouping: true,
          //   size: 50,
        },
        {
          accessorKey: "departmentName",
          header: "Phòng ban",
          //  enableGrouping: true,
          //   size: 50,
        },
        {
          accessorKey: "roleName",
          header: "Chức vụ",
          //  enableGrouping: true,
          //   size: 50,
        },
        // {
        //   accessorKey: "phoneNumber",
        //   header: "Điện thoại",
        //   //  enableGrouping: true,
        //   //   size: 50,
        // },
        // //  {
        // //    accessorKey: "dateOfBirth",
        // //    header: "Ngày sinh",
        // //  },
        // {
        //   accessorKey: "address",
        //   header: "Địa chỉ",
        //   //  enableGrouping: true,
        //   //   size: 50,
        // },
        // {
        //   accessorKey: "description",
        //   header: "Ghi chú",
        //   //  enableGrouping: true,
        //   //   size: 50,
        // },
      ] as MRT_ColumnDef<(typeof data)[0]>[],
    []
  );

  const startCountdown = () => {
    if (!isCounting) {
      setTimeLeft(_timerDelayClick);
      setIsCounting(true);
    }
  };

  const handleChangeSearchValue = (value: string, key: string) => {
    setSearch((prevData) => ({ ...prevData, [key]: value }));
  };

  const fetchData = async () => {
    setIsLoading(true);
    setIsRefetching(true);
    setIsError(false);

    let url = `?Skip=${pagination?.pageIndex * pagination?.pageSize}&Take=${
      pagination.pageSize
    }`;
    // let url = `?BranchId=${Number(selectedBranch?.value)}&Skip=${
    //   pagination?.pageIndex * pagination?.pageSize
    // }&Take=${pagination.pageSize}`;

    if (search.roleId) {
      url += `&RoleId=${search.roleId}`;
    }
    if (search.departmentId) {
      url += `&DepartmentId=${search.departmentId}`;
    }
    if (search.managerId) {
      url += `&ManagerId=${search.managerId}`;
    }
    if (search.branchId) {
      url += `&BranchId=${search.branchId}`;
    }

    if (search.keySearch) {
      url += `&KeySearch=${search.keySearch}`;
    }

    try {
      const response = await repositoryPos.get(
        `/api/v1/TblDmEmployee/get-list${url}`
      );
      if (response && response.success) {
        let result = response?.data;
        setData(result);
        setDataTemp(result);
        setRowCount(response?.totalCount);
        setSelectIds([]);
        table.resetRowSelection();
      } else {
        setData([]);
      }
    } catch (error) {
      setData([]);
      setIsError(true);
      console.error(error);
      return;
    } finally {
      setIsLoading(false);
      setIsRefetching(false);
    }
    startCountdown();
  };

  useEffect(() => {
    // if(paramDetailsEditEmployeeByBranch?.data.employeeFund){
    if (dataBranch.length > 0) {
      fetchData();
      // }
    }
  }, [dataBranch, pagination.pageIndex, pagination.pageSize]);

  useEffect(() => {
    if (paramDetailsEditEmployeeByBranch?.data.employeeFund) {
      const selectedBranch = dataBranch?.find(
        (item) =>
          String(item.att2) ===
          String(paramDetailsEditEmployeeByBranch?.data.branchesFund ?? "")
      );
      handleChangeSearchValue(selectedBranch?.value || "", "branchId");
    }
  }, [dataBranch, paramDetailsEditEmployeeByBranch?.data.employeeFund]);

  useEffect(() => {
    if (search.branchId && isFirstFetch) {
      fetchData();
      setIsFirstFetch(false);
    }
  }, [search.branchId]);
  // Hàm gọi API nhân viên
  const fetchDataBranch = async () => {
    const dataApi = await repositoryPos.get<MessageResponse<any>>(
      "/api/v1/TblDmInventory/get-select-branch"
    );

    if (dataApi && dataApi.success) {
      const filteredData = dataApi.data.slice(1);
      setDataBranch(filteredData);
    }
  };

  const fetchDataDepartment = async () => {
    const getDataDepartment = await getTblDepartmentSelect();

    const mappedData = getDataDepartment
      .filter(
        (item) => item.value != null && item.text != null && item.value !== "-1"
      )
      .map((item) => ({
        value: item.value,
        label: `${item.text}`,
      }));
    setDataDepartment(mappedData);
  };

  const fetchDataRole = async () => {
    const response = await getTblRoleSelect();
    const mappedData = response
      .filter(
        (item) => item.value != null && item.text != null && item.value !== "-1"
      )
      .map((item) => ({
        value: item.value,
        label: `${item.text}`,
      }));
    setDataRole(mappedData);
  };

  useEffect(() => {
    fetchDataBranch();
  }, []);

  useEffect(() => {
    let timer: ReturnType<typeof setInterval>;
    if (isCounting && timeLeft > 0) {
      timer = setInterval(() => {
        setTimeLeft((prevTime) => prevTime - 1);
      }, 1000);
    } else if (timeLeft === 0) {
      setIsCounting(false);
    }
    return () => clearInterval(timer);
  }, [isCounting, timeLeft]);

  // useEffect(() => {
  //   const valuesList = Object.keys(rowSelection);
  //   setSelectIds(valuesList);
  //   if (valuesList.length < 1) setSelectIds([]);
  //   else {
  //     const valuesList = Object.keys(rowSelection);
  //     setSelectIds(valuesList);
  //   }
  // }, [rowSelection]);

  const table = useMantineReactTable({
    columns,
    data,
    positionToolbarAlertBanner: "bottom",
    columnFilterDisplayMode: "popover",
    enableTopToolbar: false,
    mantineTopToolbarProps: {
      style: {
        borderBottom: "3px solid rgba(128, 128, 128, 0.5)",
        marginBottom: 5,
      },
    },
    localization: _localization,
    enableRowSelection: false,
    getRowId: (row) => row.code,
    initialState: {
      showColumnFilters: false,
      columnPinning: {
        left: ["groupCode"],
        right: ["action"],
      },
      columnVisibility: { id: false },
      density: "xs",
      pagination: { pageSize: 25, pageIndex: 0 },
    },
    mantineTableContainerProps: {
      style: { maxHeight: "62.5vh", minHeight: "300px" },
    },
    enableStickyHeader: true,
    // onRowSelectionChange: setRowSelection,
    onPaginationChange: (e) => {
      setPagination(e);
    },
    // manualFiltering: true,
    manualPagination: true,
    // manualSorting: true,
    rowCount,
    // onColumnFiltersChange: setColumnFilters,
    // onGlobalFilterChange: setGlobalFilter,
    // onSortingChange: setSorting,
    mantineTableBodyCellProps: ({ row }) => ({
      style: styleTableMantine,
    }),
    state: {
      // columnFilters,
      // globalFilter,
      isLoading,
      pagination,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      showSkeletons: isLoading, //loading for the first time with no data
      //sorting,
      rowSelection,
    },
    mantineToolbarAlertBannerProps: isError
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      rowsPerPageOptions: ["25", "50", "100"],
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
    },
    // mantineTableBodyRowProps: ({ row }) => ({
    //   onClick: row.getToggleSelectedHandler(),
    //   sx: { cursor: "pointer" },
    // }),
    mantineTableBodyRowProps: ({ row }) => ({
      onDoubleClick: () => {
        if (paramDetailsEditEmployeeByBranch) {
          paramDetailsEditEmployeeByBranch.node.setDataValue(
            "employeeFund",
            row.original.code
          );
          // paramDetailsEditEmployeeByBranch.node.setDataValue(
          //   "debtObjectName",
          //   row.original.groupName
          // );
        }

        //   handleChooseCustomer(
        //     row.original,
        //     isChooseCongNo,
        //     openFormCustomer,
        //     children,
        //     RowIndex
        //   );
        modals.closeAll();
      },
      sx: {
        cursor: "pointer", //you might want to change the cursor too when adding an onClick
      },
    }),
  });

  return (
    <>
      <div style={{ marginTop: "10px" }} ref={headerRef}>
        <Grid>
          <Grid.Col span={{ base: 12 }}>
            <Grid align="center" gutter={"xs"}>
              <Grid.Col span={sizeGrid}>
                <Input
                  flex={1}
                  placeholder="Nhập từ khóa tìm kiếm"
                  type="text"
                  w={"100%"}
                  leftSection={
                    <IconSearch
                      size={"20"}
                      color={cobalt_blue.base}
                    ></IconSearch>
                  }
                  onChange={(e) => {
                    handleChangeSearchValue(e.target.value ?? "", "keySearch");
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      fetchData();
                    }
                  }}
                />
              </Grid.Col>
              <GridCol span={sizeGrid}>
                <Select
                  searchable
                  clearable
                  placeholder="Chọn chi nhánh"
                  comboboxProps={{
                    transitionProps: { transition: "pop", duration: 200 },
                  }}
                  value={
                    dataBranch?.find(
                      (item: SelectListItemBase) =>
                        item.value === search.branchId
                    )?.value || null
                  }
                  leftSection={<IconBuildingStore color="#15aabf" />}
                  nothingFoundMessage={"Loading..."}
                  data={dataBranch
                    ?.sort((a: any, b: any) => a.att2 - b.att2)
                    .map((ele, index) => {
                      return {
                        label: ele.text,
                        value: ele.value,
                      };
                    })
                    .slice(1)}
                  onChange={(value) => {
                    handleChangeSearchValue(value || "", "branchId");
                  }}
                />
              </GridCol>
              <GridCol span={sizeGrid}>
                <Select
                  searchable
                  clearable
                  placeholder="Chọn phòng ban"
                  comboboxProps={{
                    transitionProps: { transition: "pop", duration: 200 },
                  }}
                  leftSection={<IconBuilding color="#15aabf" />}
                  nothingFoundMessage={"Loading..."}
                  data={dataDepartment}
                  onChange={(value) => {
                    handleChangeSearchValue(value || "", "departmentId");
                  }}
                  onClick={() => {
                    if (dataDepartment.length === 0) {
                      fetchDataDepartment();
                    }
                  }}
                />
              </GridCol>
              <GridCol span={sizeGrid}>
                <Select
                  placeholder={"Chọn chức vụ"}
                  searchable
                  clearable
                  data={dataRole}
                  leftSection={<IconUserCircle color="#15aabf" />}
                  comboboxProps={{
                    transitionProps: { transition: "pop", duration: 200 },
                  }}
                  nothingFoundMessage={"Loading..."}
                  onChange={(value) =>
                    handleChangeSearchValue(value || "", "roleId")
                  }
                  onClick={() => {
                    if (dataRole.length === 0) {
                      fetchDataRole();
                    }
                  }}
                />
              </GridCol>
              {/* <Grid.Col span={gridSpan}>
                  <Input
                    flex={1}
                    placeholder="Nhập mã số thuế"
                    type="text"
                    w={"100%"}
                    leftSection={
                      <IconFileText
                        size={"20"}
                        color={cobalt_blue.base}
                      ></IconFileText>
                    }
                    onChange={(e) => {
                      handleChangeSearchValue(e.target.value ?? "", "TaxCode");
                    }}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        fetchData();
                      }
                    }}
                  />
                </Grid.Col>
                <Grid.Col span={gridSpan}>
                  <Input
                    flex={1}
                    placeholder="Nhập số điện thoại"
                    type="text"
                    w={"100%"}
                    leftSection={
                      <IconPhone size={"20"} color={cobalt_blue.base}></IconPhone>
                    }
                    onChange={(e) => {
                      handleChangeSearchValue(e.target.value ?? "", "Phone");
                    }}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        fetchData();
                      }
                    }}
                  />
                </Grid.Col> */}
              <Grid.Col span={sizeGrid}>
                <Button
                  leftSection={<IconSearch size={14} />}
                  color="blue"
                  variant="outline"
                  onClick={async () => {
                    await fetchData();
                  }}
                >
                  Tìm kiếm
                </Button>
              </Grid.Col>
            </Grid>
          </Grid.Col>
        </Grid>
      </div>
      <div>
        <MantineReactTable table={table} />
      </div>
    </>
  );
};

export default CustomerByBranch;
